export default "__VITE_ASSET__BBZnN8w1__"